<template>
  <div>
    <div class="-mx-6 px-6 rounded bg-bg py-4 group-grid
                text-sm text-text-ternary text-right">
      <div></div>
      <div class="text-left">{{ $t('assets') }}</div>
      <div>{{ $t('share') }}</div>
      <div>{{ $t('cost') }}, {{ portfolioCurrency.symbol }}</div>
      <div>{{ $t('profitability') }}</div>
      <div>{{ $t('dynamicsPerDay') }}, {{ portfolioCurrency.symbol }}</div>
      <div>{{ $t('dynamicsPerMonth') }}, {{ portfolioCurrency.symbol }}</div>
      <div>{{ $t('dynamicsAllTime') }}, {{ portfolioCurrency.symbol }}</div>
    </div>
    <div class="divide-y divide-border">
      <PortfolioStructureItem v-for="(item,i) in portfolioAssetsWOCurrencies" :key="i"
                              :class="{'-mt-px': i !== 0}"
                              :asset-group="item"/>
    </div>
    <template v-if="!!portfolioAssetsCurrencies.length">
      <PortfolioCurrencyItem v-for="(item,i) in portfolioAssetsCurrencies" :key="'currency-'+i"
                             :class="{'border-t border-border': i === 0 && !!portfolioAssetsWOCurrencies.length}"
                             :currency="item"/>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import PortfolioStructureItem
  from "@/components/cabinet/Investments/Dashboard/PortfolioStructure/PortfolioStructureItem/PortfolioStructureItem";
import PortfolioCurrencyItem
  from "@/components/cabinet/Investments/Dashboard/PortfolioStructure/PortfolioStructureItem/PortfolioCurrencyItem";

export default {
  name: "PortfolioStructureList",
  components: {PortfolioCurrencyItem, PortfolioStructureItem},
  props: ['portfolioAssets'],
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
    portfolioAssetsWOCurrencies() {
      return this.portfolioAssets.filter(i => i.properties.type !== 4)
    },
    portfolioAssetsCurrencies() {
      return this.portfolioAssets.filter(i => i.properties.type === 4)[0].assets;
    }
  },
  methods: {
    assetName(type) {
      switch (type) {
        case 1:
          return 'Акции'
        case 2:
          return 'Облигации'
        case 3:
          return 'Фонд'
        case 4:
          return 'Валюта'
        case 5:
          return 'Другое'
      }
    }
  },
  i18n: {
    messages: {
      en: {
        assets: 'Assets',
        share: 'Share',
        cost: 'Cost',
        profitability: 'Profitability',
        dynamicsPerDay: 'Dynamics per day',
        dynamicsPerMonth: 'Dynamics per month',
        dynamicsAllTime: 'All time'
      },
      ru: {
        assets: 'Активы',
        share: 'Доля',
        cost: 'Стоимость',
        profitability: 'Доходность',
        dynamicsPerDay: 'Динамика за день',
        dynamicsPerMonth: 'Динамика за месяц',
        dynamicsAllTime: 'За все время'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.group-grid {
  display: grid;
  grid-template-columns: 4rem 8.1% 7.6% 12% 10.3% 14.6% 15.9% 17.7%;
  grid-column-gap: 1.5rem;
}
</style>